import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "./App";
import FileTranslatePage from "./style/FileTranslatePage";
import AiToolsPage from "./page/main/AiToolsPage";
import PaymentComplete from "./page/main/PaymentComplete";
import { TransactionHistory } from "./page/main/TransactionHistory";
import AdminLayout from "./AdminLayout";
import BlogList from "./page/admin/blog/Blog";
import Seo from "./page/admin/Seo";
import Content from "./page/admin/Content";
import AdminLoginPage from "./page/admin/AdminLogin";
import BlogPage from "./page/main/Blog";
import BlogDetail from "./page/main/BlogDetail";
import BlogAdminDetail from "./page/admin/blog/BlogDetail";
import BlogDetailPage from "./page/admin/blog/BlogDetailPage";
import PageList from "./page/admin/page/Page";
import PageDetailPage from "./page/admin/page/PageDetailPage";
import SettingForm from "./page/admin/SettingForm";
import FaqPage from "./page/main/FaqPage";
import ToneAdmin from "./page/admin/Tone";
import SitemapPage from "./page/main/SiteMap";
import UserList from "./page/admin/user/UserList";
import { AdminTransactionHistory } from "./page/admin/file/AdminTransactionHistory";
import DashboardPage from "./page/admin/dashboard";
import BlogFooterList from "./page/admin/blogfooter/Blog";
import BlogFooterDetailPage from "./page/admin/blogfooter/BlogDetailPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <AiToolsPage /> }, // 👈 giữ URL "/"
      { path: "translate", element: <AiToolsPage /> },
    ],
  },
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Navigate to="/transaction" replace /> },
      { path: "transaction", element: <PaymentComplete /> },
    ],
  },
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Navigate to="/transaction-histories" replace />,
      },
      { path: "transaction-histories", element: <TransactionHistory /> },
    ],
  },
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Navigate to="/blog" replace />,
      },
      { path: "blog", element: <BlogPage /> },
    ],
  },
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Navigate to="/blog-detail" replace />,
      },
      {
        path: "blog-detail",
        element: <BlogDetail />,
      },
      {
        path: ":slug",
        element: <BlogDetail />,
      },
    ],
  },
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Navigate to="/faq" replace />,
      },
      {
        path: "faq",
        element: <FaqPage />,
      },
    ],
  },
  {
    path: "/",
    children: [
      {
        index: true,
        element: <Navigate to="/sitemap" replace />,
      },
      {
        path: "sitemap",
        element: <SitemapPage />,
      },
    ],
  },
  {
    path: "/:slug",
    element: <BlogDetail />,
  },
  {
    path: "/admin-login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      {
        path: "dashboard",
        children: [{ index: true, element: <DashboardPage /> }],
      },
      {
        path: "blog",
        children: [
          { index: true, element: <BlogList /> },
          { path: "detail", element: <BlogDetailPage /> }, // create
          { path: "detail/:id", element: <BlogDetailPage /> },
        ],
      },
      {
        path: "support",
        children: [
          { index: true, element: <BlogFooterList /> },
          { path: "detail", element: <BlogFooterDetailPage /> }, // create
          { path: "detail/:id", element: <BlogFooterDetailPage /> },
        ],
      },
      {
        path: "user",
        children: [{ index: true, element: <UserList /> }],
      },
      {
        path: "file",
        children: [{ index: true, element: <AdminTransactionHistory /> }],
      },
      {
        path: "page",
        children: [
          { index: true, element: <PageList /> },
          { path: "detail", element: <PageDetailPage /> }, // create
          { path: "detail/:id", element: <PageDetailPage /> },
        ],
      },
      {
        path: "tone",
        children: [{ index: true, element: <ToneAdmin /> }],
      },
      {
        path: "setting",
        children: [{ index: true, element: <SettingForm /> }],
      },
      // {
      //   path: "seo",
      //   children: [
      //     { index: true, element: <Seo /> },
      //     // { path: "create", element: <BlogCreate /> },
      //   ],
      // },
      // {
      //   path: "content",
      //   children: [
      //     { index: true, element: <Content /> },
      //     // { path: "create", element: <BlogCreate /> },
      //   ],
      // },
    ],
  },
]);
